export const ROUTE_URL = {
  ENGAGEMENTPREPARATION: {
    DEFINEEMPLOYEES: '/engagement-preparation/employee-information/',
    DEFINEPROJECTS: '/engagement-preparation/define-projects/',
  },
  ENGAGEMENTINSIGHTS: '/survey-insight/wage-survey-list',
  ENGAGEMENTINSIGHTS1: '/survey-insight/wage-survey-list',
  DATAANALYSISSUMMARY: '/data-analysis-summary',
  HOME: 'home',
  HOME1: '/home',
  BLANK: '',
  ADMIN: {
    KPMGUSER: 'admin/user',
  },
  STUDIES:'/studies',
  REPORTS:'reports',
  CREDITREPORTS:'credit-reports',
  REVIEWQNQ:'reviewQNQ',
  EXPENSESURVEYLIST: '/survey-insight/expense-surveys',
  WAGE_SURVEY_LIST: (engagementId: string) => '/study/' + engagementId + '/surveys/wage-survey-list',
  CLIENTMANAGER_SURVEY_LIST: (engagementId: string) => '/study/' + engagementId + '/surveys/cm-survey-list',
  EXPENSE_SURVEY: (engagementId: string) => '/study/' + engagementId + '/surveys/expense-survey',
  PROJECT_SURVEY_LIST: (engagementId: string) => '/study/' + engagementId + '/surveys/project-survey-list',
  // TIME_SURVEY: (engagementId: string, surveyID: string) => '/survey/study/' + engagementId + '/time-survey-detail/' + surveyID,
  TIME_SURVEY: (engagementId: string, surveyID: string) => '/study/' + engagementId + '/surveys/wage-survey-list/' + surveyID,

  STUDYHOME: (engagementId: string) => '/study/' + engagementId + '/home',
  EMPLOYEE_DATA: (engagementId: string) => '/study/' + engagementId + '/data-import/employee-data',
  MANAGE_PROJECT: (engagementId: string) => '/study/' + engagementId + '/data-import/manage-project',
  MANAGE_BUSINESS_COMPONENT:(engagementId: string) => '/study/' + engagementId + '/data-import/business-component',
  MANAGE_ACTIVITY: (engagementId: string) => '/study/' + engagementId + '/data-import/manage-activity',
  AGILE_ANALYZER: (engagementId: string) => '/study/' + engagementId + '/data-import/agile-analyzer',
  LEGAL_ENTITY: (engagementId: string) => '/study/' + engagementId + '/data-import/legal-entity',

  // SURVEY_INFO: (engagementId: string, surveyID: string) => '/survey/study/' + engagementId + '/survey-detail/' + surveyID,
  SURVEY_INFO: (engagementId: string, surveyID: string) => '/study/' + engagementId + '/surveys/expense-survey/' + surveyID,

  EXPENSE_DATA: (engagementId: string) => '/study/' + engagementId + '/data-import/expense-data',
  TIME_TRACKING_DATA: (engagementId: string) => '/study/' + engagementId + '/data-import/time-tracking-data',
  CREATE_SURVEY: (engagementId: string) => '/study/' + engagementId + '/surveys/create-survey',
  CREATE_EXPENSE_SURVEY: (engagementId: string) => '/study/' + engagementId + '/surveys/expense-survey/create',
  CREATE_PROJECT_SURVEY: (engagementId: string) => '/study/' + engagementId + '/surveys/project-survey/create',
  CLIENTSMESURVEY_INFO: (engagementId: string, surveyID: string) => '/survey/study/' + engagementId + '/survey-detail/' + surveyID + '/smeview',
  INTERVIEWS: (engagementId: string) => '/study/' + engagementId + '/scheduling-tool',
  DASHBOARD_INSIGHTS: (engagementId: string) => '/study/' + engagementId + '/dashboard-insights',
  MANAGE_DOCUMENTS: (engagementId: string) => '/study/' + engagementId + '/manage-documents',
  ASSIGN_PROJECT_ACTIVITIES: (engagementId: string) => '/study/' + engagementId + '/surveys/time-survey/assign-activities',
  QRE_REPORTS: (engagementId: string) => '/study/' + engagementId + '/reports/reports',
  QNQ_REVIEW: (engagementId: string) => '/study/' + engagementId + '/reports/reviewQNQ',
  CREDIT_REPORTS: (engagementId: string) => '/study/' + engagementId + '/reports/credit-reports',
  TEMPLATE_MEMO_GENERATOR: (engagementId: string) => '/study/' + engagementId + '/reports/template-generator',
  ADMIN_USER:'/admin/user',
  ADMIN_CLIENT_USER:'/admin/admin-client-user',
  RECONCILATION_SURVEY: '../reconcilation', 
  NAVIGATION_RECONCILIATION_SURVEY: (engagementId: string) => '/study/' + engagementId + '/surveys/reconcilation',
  PROJECT_SURVEY_INFO: (engagementId: string, surveyID: string) => '/study/' + engagementId + '/surveys/project-survey-detail/' + surveyID,
  STUDYEDIT: (engagementId: string) => '/study-edit/' + engagementId ,
  
  
  
};
